/**
 * 전체메뉴 (/m/menu — 서랍 page 모드) — 시트를 그리고 당겨서 새로고침을 시트 본문에 건다
 * ($j.Pages.Mobile.Menu / body data-page-name="Menu")
 */
export default class Menu {
    initialize() {
        // '최근·자주 사용한 메뉴' 사용기록은 서버가 내려주지 않는다 —
        // 기기(localStorage `m:menu:use:{회원번호}`)가 정본이고 renderMenu 가 그릴 때 동기로 읽는다.
        $(function(){
            // 시트 모드 — 제목·설정·닫기를 가진 자기 헤더를 그린다(_sheetHeadHtml).
            // 서랍(오버레이)의 프로필 인사말 줄은 쓰지 않는다 — 여기선 프로필 카드가 그 몫을 한다.
            $j.F.Mobile.Layout.renderMenu('#menuPage');

            // 당겨서 새로고침 — 이 화면은 .jb-menu-page 가 position:fixed 시트라 문서(body)는 스크롤이 없고,
            // 부트스트랩이 body 기준으로 켠 PullRefresh 는 fixed 상위 요소를 모달로 보고 당김을 막는다.
            // 실제 스크롤러(.jb-sheet-body, renderMenu 가 방금 그림)를 지정해 다시 켠다.
            // 스피너는 시트 헤더 아래 드러나는 틈에 맞춘다(anchorIndicator) — 뷰포트 맨 위면 대메뉴 바 위에 뜬다.
            $j.Ui.PullRefresh.disable();
            $j.Ui.PullRefresh.enable({ scroller: '.jb-sheet-body', anchorIndicator: true });
        });

    }
}
